import React from 'react';
import { Container, Button, Card, Row, Col, Form } from 'react-bootstrap';
import MasterPage from 'components/MasterPage';
import { useEffect } from 'react';
import { useState } from 'react';
import ResalesRequestService from '../../services/resales-request';
import ActionRequestService from '../../services/action-request';
import { ActionStatus, FundType } from '../../helpers/Enum/index';
import { WidgetsOutlined, ArrowBackIos } from '@material-ui/icons';
import { parseDateBR } from 'helpers/date.js';
import BootstrapTable from 'react-bootstrap-table-next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import Unauthorized from 'components/Unauthorized';
import SelectFiscalYears from 'components/SelectFiscalYears';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Loading from 'components/Loading';
import { useHistory } from 'react-router-dom';
import { useCompany, useUser } from 'models';


export default function(){
  const user = useUser();
  const {company:currentCompany} = useCompany();
  const [flow, setFlow] = useState(null);
  const [funds, setFunds] = useState([]);
  const [spendings, setSpendings] = useState(null);

  const [fiscalYear, setFiscalYear] = useState(10);

  const [isLoading, setIsLoading] = useState(false);

  const [companyId, setCompanyId] = useState(
    currentCompany
      ? currentCompany.id
      : user.currentCompany ? user.currentCompany.id : '');

  const history = useHistory();

  useEffect(() => {
    if(currentCompany){
      changeFiscalYear(fiscalYear);
      getFlow();
      getStatement();
    }else{
      showMessageErro();
    }
  }, []);

  useEffect(() => {
    if (flow && funds.length > 0) {
      setSpendings(
        buildFullDemonstrative(Object.values(flow.action_status), funds)
      );
    }
  }, [flow, funds]);

  const changeFiscalYear = (id) => {
    const filter = {
      fiscal_year_id: id,
      company_id: currentCompany
        ? currentCompany.id
        : user.currentCompany.id
    };
    let companies = ResalesRequestService.getGroupHeadquarter({
      params: { ...filter },
    });
    companies.then((data) => {
      let c = data.data.data;
      setCompanyId(data.data.data.company_id)
      setFiscalYear(id);
      getStatement(parseInt(id), c.company_id);
    });
  }

  const getFlow = () => {
    let request = ActionRequestService.getFlow(1);
    request.then((data) => {
      setFlow(data.data.data);
    });
  };

  useEffect(() => {
    getStatement();
  }, [fiscalYear]);

  const getStatement = (fiscal_year_id = null, company_id = null) => {
    setIsLoading(true);
    let filters = {
      embed: 'actions',
      fiscal_year_id: fiscal_year_id ?? fiscalYear,
      
    };

    if (currentCompany) {
      let request = ResalesRequestService.getCompanyFunds(
        company_id ?? companyId,
        { params: { ...filters } }
      );
      request.then((data) => {
        let result = data.data.data;
        // setFunds(result.funds.filter(a=>a.business_unity_id == 3));
        setFunds(result.funds);
      }).finally(() => setIsLoading(false));
    } else {
      return showMessageErro();
    }
  };

  const buildFullDemonstrative = (actionStatus, funds) => {
    let spendings = {
      actions: [],
      completed: {},
      'total-others': {},
      others: {},
      'total-completed': {},
      'available-fund': {},
      'free-fund': {},
    };

    actionStatus.forEach((item) => {
      funds.forEach((fund) => {
        if (!spendings['total-others'][fund.id])
          spendings['total-others'][fund.id] = 0;

        let actions = fund.actions.filter(
          (action) => action.action_status_id === item.id
        );

        switch (item.id) {
          case ActionStatus().Finalizada:
            actions.forEach((action) => {
              spendings['actions'].push(action);
            });
            spendings['total-completed'][fund.id] = actions.reduce(
              (total, value) => {
                return total + value.pivot.value;
              },
              0
            );
            break;
          case ActionStatus().Cancelada:
            break;
          default:
            if (!spendings['others'][item.id])
              spendings['others'][item.id] = {};
            spendings['others'][item.id]['status'] = item.name;
            spendings['others'][item.id][fund.id] = actions.reduce(
              (total, value) => {
                return total + value.pivot.value;
              },
              0
            );
            spendings['total-others'][fund.id] +=
              spendings['others'][item.id][fund.id];
        }
      });
    });
    let dates = spendings['actions']
      .map((a) => {
        return a.pay_date;
      })
      .filter((a, k, self) => self.indexOf(a) === k)
      .sort();
    dates.forEach((date) => {
      funds.forEach((fund) => {
        if (!spendings['completed'][date]) spendings['completed'][date] = {};
        spendings['completed'][date][fund.id] = spendings['actions']
          .filter((a) => a.pay_date === date && a.pivot.fund_id === fund.id)
          .reduce((total, value) => {
            return total + value.pivot.value;
          }, 0);
      });
    });

    funds.map((fund) => {
      spendings['available-fund'][fund.id] =
        fund.pivot.value - spendings['total-completed'][fund.id];
      spendings['free-fund'][fund.id] =
      parseFloat(spendings['available-fund'][fund.id]).toFixed(2) -
      parseFloat(spendings['total-others'][fund.id]).toFixed(2);
    });
    return spendings;
  };

  const showMessageErro = () => {
    return <Unauthorized />;
  };

  var Data = [];

  const renderData = () => {
    var keys = [
      // 'mkt_pos',
      // 'mkt_comm',
      // 'des_merc_pos',
      // 'des_merc_comm',
      // 'rebate_pos',
      // 'rebate_comm',
      // 'mkt',
      // 'des_merc',
      // 'rebate',
    ];
    if(fiscalYear <= 9 ){
      keys.push(
        'mkt_pos',
        'mkt_comm',
        'des_merc_pos',
        'des_merc_comm',
        'rebate_pos',
        'rebate_comm'
      );
    } else {
      keys.push(
        'mkt',
        'des_merc',
        'rebate'
      );
    }
    let valorAcumulado = { key: 20 };
    let valoresPagos = { key: 21 };
    let saldoDisponivel = { key: 22 };
    let saldoLivre = { key: 23 };

    if (funds) {
      valorAcumulado['name'] = <b>Valor acumulado</b>;
      funds.forEach((item, k) => {
        valorAcumulado[item.name] = (
          <b>
            {item.pivot.value.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
          </b>
        );
      });
    }
    if (spendings) {
      valoresPagos['name'] = 'Valores pagos';
      Object.values(spendings['total-completed']).forEach((item, k) => {
        valoresPagos[keys[k]] = (
          <p className="text-success">
            {item.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
          </p>
        );
      });

      saldoDisponivel['name'] = <b>Saldo disponível</b>;
      Object.values(spendings['available-fund']).forEach((item, k) => {
        saldoDisponivel[keys[k]] = (
          <b>
            {item.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
          </b>
        );
      });

      Data.push(valorAcumulado, valoresPagos);
      Data.push(saldoDisponivel);

      Object.values(spendings['others']).forEach((item, k) => {
        let status = { key: k };
        status['name'] = item['status'];
        funds.map((fund, i) => {
          status[keys[i]] = (
            <p className="text-danger" key={i}>
              {item[fund.id].toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              })}
            </p>
          );
        });
        Data.push(status);
      });

      saldoLivre['name'] = <b>Saldo livre</b>;
      Object.values(spendings['free-fund']).forEach((item, k) => {
        saldoLivre[keys[k]] = (
          <b>
            {item.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
          </b>
        );
      });
      Data.push(saldoLivre);
    }
    if(funds.length == 0){
      Data = [];
    }
  };

  const columns = [
    {
      dataField: 'key',
      text: '',
      style: {
        display: 'none',
      },
      headerStyle: {
        display: 'none',
      },
    },
    {
      dataField: 'name',
      text: '',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center',
      },
    },
    // {
    //   dataField: 'mkt_pos',
    //   text: 'Marketing POS',
    //   headerStyle: {
    //     textAlign: 'center',
    //   },
    //   style: {
    //     textAlign: 'center',
    //   },
    // },
    // {
    //   dataField: 'mkt_comm',
    //   text: 'Marketing COMMS',
    //   headerStyle: {
    //     textAlign: 'center',
    //   },
    //   style: {
    //     textAlign: 'center',
    //   },
    // },
    // {
    //   dataField: 'des_merc_pos',
    //   text: 'Des. Mercado POS',
    //   headerStyle: {
    //     textAlign: 'center',
    //   },
    //   style: {
    //     textAlign: 'center',
    //   },
    // },
    // {
    //   dataField: 'des_merc_comm',
    //   text: 'Des. Mercado COMMS',
    //   headerStyle: {
    //     textAlign: 'center',
    //   },
    //   style: {
    //     textAlign: 'center',
    //   },
    // },
    // {
    //   dataField: 'rebate_pos',
    //   text: 'Rebate POS',
    //   headerStyle: {
    //     textAlign: 'center',
    //   },
    //   style: {
    //     textAlign: 'center',
    //   },
    // },
    // {
    //   dataField: 'rebate_comm',
    //   text: 'Rebate COMMS',
    //   headerStyle: {
    //     textAlign: 'center',
    //   },
    //   style: {
    //     textAlign: 'center',
    //   },
    // },
    // {
    //   dataField: 'mkt',
    //   text: 'Marketing',
    //   headerStyle: {
    //     textAlign: 'center',
    //   },
    //   style: {
    //     textAlign: 'center',
    //   },
    // },
    // {
    //   dataField: 'des_merc',
    //   text: 'Des. Mercado',
    //   headerStyle: {
    //     textAlign: 'center',
    //   },
    //   style: {
    //     textAlign: 'center',
    //   },
    // },
    // {
    //   dataField: 'rebate',
    //   text: 'Rebate',
    //   headerStyle: {
    //     textAlign: 'center',
    //   },
    //   style: {
    //     textAlign: 'center',
    //   },
    // },
  ];

  if(fiscalYear <= 9){
    columns.push({
      dataField: 'mkt_pos',
      text: 'Marketing POS',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center',
      },
    },
    {
      dataField: 'mkt_comm',
      text: 'Marketing COMMS',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center',
      },
    },
    {
      dataField: 'des_merc_pos',
      text: 'Des. Mercado POS',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center',
      },
    },
    {
      dataField: 'des_merc_comm',
      text: 'Des. Mercado COMMS',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center',
      },
    },
    {
      dataField: 'rebate_pos',
      text: 'Rebate POS',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center',
      },
    },
    {
      dataField: 'rebate_comm',
      text: 'Rebate COMMS',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center',
      },
    })
  } else {
    columns.push({
      dataField: 'mkt',
      text: 'Marketing',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center',
      },
    },
    {
      dataField: 'des_merc',
      text: 'Des. Mercado',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center',
      },
    },
    {
      dataField: 'rebate',
      text: 'Rebate',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center',
      },
    });
  }

  const expandRow = {
    renderer: (row) => (
      <table style={{ width: '100%' }}>
        {spendings
          ? Object.values(spendings['completed']).map((actions, k) => {
            return (
              <tr key={k}>
                <td class="table-1 text-right">
                  <b>{parseDateBR(Object.keys(spendings['completed'])[k])}</b>
                </td>
                {Object.values(actions).map((action, k) => {
                  return (
                    <td key={k} class="table-2 text-right text-success">
                      <b>
                        {action.toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        })}
                      </b>
                    </td>
                  );
                })}
              </tr>
            );
          })
          : ''}
      </table>
    ),
    showExpandColumn: true,
    nonExpandable: [20, 22, 23, 0, 1, 2, 3, 4, 5, 6, 7],
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      if (isAnyExpands) {
        return '';
      }
      return '';
    },
    expandColumnRenderer: ({ expanded, rowKey, expandable }) => {
      if (expanded) {
        return <FontAwesomeIcon icon={faMinusCircle} />;
      }
      if (expandable) return <FontAwesomeIcon icon={faPlusCircle} />;
      return '';
    },
  };
const getTamanho = (tamanho)=>{
    return window.innerWidth<=tamanho;
  }

  renderData();
  return (
    <>
      {currentCompany ? (
        <Container>
          <Row className="mt-4">
            <Button variant="link" className="link-back" onClick={() => history.goBack()}>
              <ArrowBackIos className="icon-title icon-back" />
              <h6 className="font-13 mt-3">Voltar</h6>
            </Button>
          </Row>
          <Row className="col-12 mt-4 row">
            <Col md={'10 row'}>
              <WidgetsOutlined className="icon-title" />
              <h5 className="title-dashboard">Extrato</h5>
            </Col>
          </Row>
          <Row>
            <Card.Body className="card-dashboard shadow bg-white rounded text-center m-2 col-12">
              <Row className="mt-2 mb-5">
                <Col md={1} className="mb-1">
                  <ReactHTMLTableToExcel
                    id="statement-table"
                    className="btn btn-primary btn-sm float-right"
                    sheet="Statement Report"
                    filename="StatementReport"
                    table="table-to-xls"
                    buttonText="Exportar"
                  />
                </Col>
                <Col md="9" />
                {currentCompany.fiscal_years_elite.length > 1 || (currentCompany.group_years && currentCompany.group_years.length > 1) ? (
                  <Col md="2">
                    <Form.Control
                      as="select"
                      value={fiscalYear}
                      onChange={(e) => {
                        setSpendings(null);
                        setFunds([]);
                        changeFiscalYear(e.target.value)
                      }}
                      className="font-12"
                    >
                      <SelectFiscalYears company={currentCompany}/>
                    </Form.Control>
                  </Col>
                ) : (
                    ''
                  )}
              </Row>
              {isLoading ? (<Loading page />) : (
                <Row>
                  <Col md={12}>
                    {funds ? (
                      <BootstrapTable wrapperClasses={getTamanho(940)?'table-responsive':''} style={{width:'100px'}}
                        id="table-to-xls"
                        className="font-10"
                        keyField="key"
                        data={Data}
                        columns={columns}
                        bordered={false}
                        hover
                        condensed
                        expandRow={expandRow}
                      />
                    ) : (
                        ''
                      )}
                  </Col>
                </Row>
              )}
            </Card.Body>
          </Row>
        </Container>
      ) : (
          showMessageErro()
        )}
    </>
  );
};
